<template>
    <form @submit.prevent="$emit('submit')">
        <div class="block--mobile">
            <div class="row">
                <div class="col-12">
                    <h2>{{$t('form.referral.header_main')}}</h2>
                    <p>{{$t('form.referral.label_info')}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-xl-6 col-xxl-7">
                    <div class="form__group">
                        <i class="form__input__icon mdi mdi-email-outline"></i>
                        <input type="email" required v-model="email" class="form__input--text has-icon" :placeholder="$t('form.referral.placeholder_email')">
                    </div>
                </div>
                <div class="col-12 col-xl-6 col-xxl-5">
                    <div class="form__buttons">
                        <button type="submit" class="button--cta no-margin" :class="{'is-loading': busy}" :disabled="disabled">
                            {{$t('form.referral.button_submit')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
    import Vue from 'vue';
    import {Component, Model, Prop} from 'vue-property-decorator';

    const MODEL_EVENT = 'input';

    @Component
    export default class ReferralForm extends Vue {
        @Model(MODEL_EVENT, {type: String})
        value;
        @Prop({type:Boolean, default: false})
        busy;
        @Prop()
        disabled;

        created() {
            window.scrollTo(0,0);
        }

        get email() {
            return this.value;
        }

        set email(value) {
            this.$emit(MODEL_EVENT, value);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/forms/ReferralForm.vue